import ApexCharts from 'apexcharts'

const viewershipGraphs = (gsap, $container) => {
	
	/***************************************************************
		FLUID ACCORDION
	***************************************************************/

	const $fluidAccordion = $container.find('.fluid-accordion');
	if ( $fluidAccordion.length ) {

		function debounce(func, wait) {
			let timeout;
			return function(...args) {
				const context = this;
				clearTimeout(timeout);
				timeout = setTimeout(() => func.apply(context, args), wait);
			};
		}

		$fluidAccordion.each(function() {
			const $accordion = $(this);
			const $mediaElements = $accordion.closest('.viewership-stats').find('.accordion-media');

			let autoPlayInterval;
			const AUTO_PLAY_DELAY = 5000;
			let isAutoPlaying = false;
			let isHovering = false;
			let isStopped = false;
			let progressAnimation;
			let isPaused = false;

			function startAutoPlay() {
				if ($(window).width() > 640) {
					const $panels = $accordion.find('.panel');
					let currentIndex = 0;

					// Initialize all strokes
					const $strokes = $accordion.find('.expand-icon__stroke');
					$strokes.each((_, stroke) => {
						gsap.set(stroke, {
							strokeDasharray: 100,
							strokeDashoffset: 100
						});
					});

					// Trigger first panel change immediately
					const $headers = $accordion.find('.panel__header');
					if ($headers.length) {
						isAutoPlaying = true;
						
						// Update both panel and graph item
						const panel = $headers.eq(currentIndex).parent().attr('data-panel');
						
						// Update panels
						$accordion.find('.panel.open').removeClass('open');
						$headers.eq(currentIndex).parent().addClass('open');
						
						// Update graph items
						$accordion.closest('.viewership-stats').find('.graph-item').removeClass('active');
						$accordion.closest('.viewership-stats').find('.graph-item[data-panel="' + panel + '"]').addClass('active');
						
						// Trigger click to ensure all animations and states are updated
						$headers.eq(currentIndex).trigger('click');
						
						isAutoPlaying = false;
						currentIndex = (currentIndex + 1) % $headers.length;
						if (progressAnimation) {
							progressAnimation.play();
						}
					}

					autoPlayInterval = setInterval(() => {
						if (!isHovering && !isPaused) {
							const $headers = $accordion.find('.panel__header');
							if ($headers.length) {
								isAutoPlaying = true;
								
								// Update both panel and graph item
								const panel = $headers.eq(currentIndex).parent().attr('data-panel');
								
								// Update panels
								$accordion.find('.panel.open').removeClass('open');
								$headers.eq(currentIndex).parent().addClass('open');
								
								// Update graph items
								$accordion.closest('.viewership-stats').find('.graph-item').removeClass('active');
								$accordion.closest('.viewership-stats').find('.graph-item[data-panel="' + panel + '"]').addClass('active');
								
								// Trigger click to ensure all animations and states are updated
								$headers.eq(currentIndex).trigger('click');
								
								isAutoPlaying = false;
								currentIndex = (currentIndex + 1) % $headers.length;
							}
							if (progressAnimation) {
								progressAnimation.play();
							}
						}
					}, AUTO_PLAY_DELAY);
				}
			}

			function stopAutoPlay() {
				if (autoPlayInterval) {
					clearInterval(autoPlayInterval);
				}
				if (progressAnimation) {
					progressAnimation.kill();
				}
			}

			// Start auto-play when the page loads
			const observer = new IntersectionObserver((entries) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						startAutoPlay();
						observer.disconnect(); // Stop observing once we've started autoplay
					}
				});
			}, {
				threshold: 0.5 // Start when 50% of the element is visible
			});

			observer.observe($accordion[0]);

			// Handle window resize with debounce
			window.addEventListener('resize', debounce(() => {
				stopAutoPlay();
				if (window.innerWidth > 640) {
					startAutoPlay();
				}
			}, 250));

			// Bind hover events to all graph items
			$accordion.closest('.viewership-stats').find('.graph-item').on('mouseenter', function() {
				isHovering = true;
				isPaused = true;
				if (progressAnimation) {
					progressAnimation.pause();
				}
			}).on('mouseleave', function() {
				isHovering = false;
				isPaused = false;
				if (progressAnimation && !isStopped) {
					progressAnimation.resume();
				}
			});

			$accordion.find('.panel__header').on('click', function() {
				if (!isAutoPlaying) {
					stopAutoPlay();
					isStopped = true;
					isPaused = true;
				}

				const panel = $(this).parent().attr('data-panel');
				
				// Update panels
				$accordion.find('.panel.open').removeClass('open');
				$(this).parent().addClass('open');
				
				// Update graph items
				$accordion.closest('.viewership-stats').find('.graph-item').removeClass('active');
				$accordion.closest('.viewership-stats').find('.graph-item[data-panel="' + panel + '"]').addClass('active');

				// Animate the stroke for the current panel
				const stroke = $(this).find('.expand-icon__stroke')[0];
				if (stroke) {
					const length = stroke.getTotalLength();
					stroke.style.strokeDasharray = length;
					stroke.style.strokeDashoffset = length;
					progressAnimation = gsap.timeline({paused: true});

					progressAnimation.fromTo(stroke, {
						strokeDashoffset: 100,
					}, {
						strokeDashoffset: 0,
						duration: AUTO_PLAY_DELAY / 1000,
						ease: "none",
						onComplete: () => {
							stroke.style.strokeDashoffset = length;
						}
					});
				}
			});
		});
		
	}
	
	const $viewershipGraph = $container.find("#viewershipGraph");
	const $viewershipGraph2 = $container.find("#viewershipGraph2");
	const $viewershipGraph3 = $container.find("#viewershipGraph3");
	const $viewershipMobile1 = $container.find("#viewershipMobile1");
	const $viewershipMobile2 = $container.find("#viewershipMobile2");
	const $viewershipMobile3 = $container.find("#viewershipMobile3");
	
	// Store chart instances for cleanup
	let chartInstances = [];
	// Store ScrollTrigger instances for cleanup
	let scrollTriggers = [];
	// Flag to prevent chart creation during cleanup
	let isCleaningUp = false;
	
	const series1 = [
		{
			name: 'Live + SD AA (000)',
			data: [
				{
					x: 'Championship\nTelecast: Houston\nvs. Florida',
					y: 17628,
					vs: 'Houston vs. Florida',
					conference: 'Big 12 v SEC',
					seed: '1 vs. 1',
					team: 'Florida',
					dow: 'Monday',
					network: 'CBS',
					percent: '5%'
				},
				{
					x: 'Final Four:\nFlorida vs.\nAuburn',
					y: 13720,
					vs: 'Florida vs. Auburn',
					conference: 'SEC v SEC',
					seed: '1 vs. 1',
					team: 'Florida',
					dow: 'Saturday',
					network: 'CBS',
					percent: '11%'
				},
				{
					x: 'Final Four:\nDuke vs.\nHouston',
					y: 13204,
					vs: 'Duke vs. Houston',
					conference: 'SEC v SEC',
					seed: '1 vs. 1',
					team: 'Houston',
					dow: 'Saturday',
					network: 'CBS',
					percent: '9%'
				},
				{
					x: 'Regional Finals:\nMichigan ST\nvs. Auburn',
					y: 11446,
					vs: 'Michigan ST vs. Auburn',
					conference: 'Big 10 v SEC',
					seed: '5 vs. 1',
					team: 'Auburn',
					dow: 'Sunday',
					network: 'CBS',
					percent: '11%'
				},
				{
					x: 'Second Round:\nBaylor vs.\nDuke',
					y: 9513,
					vs: 'Baylor vs. Duke',
					conference: 'Big 12 v ACC',
					seed: '9 vs. 1',
					team: 'Duke',
					dow: 'Sunday',
					network: 'CBS',
					percent: '15%'
				}
			]
		},
		{
			name: 'Out of Home Live + SD AA (000)',
			data: [
				{
					x: ['Championship', 'Telecast: Houston', 'vs. Florida'],
					y: 961,
					vs: 'Houston vs. Florida',
					conference: 'Big 12 v SEC',
					seed: '1 vs. 1',
					team: 'Florida',
					dow: 'Monday',
					network: 'CBS',
					percent: '5%'
				},
				{
					x: ['Final Four:', 'Florida vs.', 'Auburn'],
					y: 1745,
					vs: 'Florida vs. Auburn',
					conference: 'SEC v SEC',
					seed: '1 vs. 1',
					team: 'Florida',
					dow: 'Saturday',
					network: 'CBS',
					percent: '11%'
				},
				{
					x: ['Final Four:', 'Duke vs.', 'Houston'],
					y: 1238,
					vs: 'Duke vs. Houston',
					conference: 'SEC v SEC',
					seed: '1 vs. 1',
					team: 'Houston',
					dow: 'Saturday',
					network: 'CBS',
					percent: '9%'
				},
				{
					x: ['Regional Finals:', 'Michigan ST', 'vs. Auburn'],
					y: 1351,
					vs: 'Michigan ST vs. Auburn',
					conference: 'Big 10 v SEC',
					seed: '5 vs. 1',
					team: 'Auburn',
					dow: 'Sunday',
					network: 'CBS',
					percent: '11%'
				},
				{
					x: ['Second Round:', 'Baylor vs.', 'Duke'],
					y: 1716,
					vs: 'Baylor vs. Duke',
					conference: 'Big 12 v ACC',
					seed: '9 vs. 1',
					team: 'Duke',
					dow: 'Sunday',
					network: 'CBS',
					percent: '15%'
				}
			]
		}
	];
	
	const series2 = [
		{
			name: 'Live + SD AA (000)',
			data: [
				{
					x: 'Second Round:\nDrake vs. Texas\nTech',
					y: 1244,
					vs: 'Drake vs. Texas Tech',
					conference: 'Missouri v Big 12',
					seed: '6 vs. 3',
					team: 'Texas Tech',
					dow: 'Saturday',
					network: 'TNT',
					percent: '62%'
				},
				{
					x: 'Second Round:\nArkansas vs. ST\nJohn\'s',
					y: 9002,
					vs: 'Arkansas vs. ST John\'s',
					conference: 'SEC v Big East',
					seed: '10 vs. 2',
					team: 'Arkansas',
					dow: 'Saturday',
					network: 'CBS',
					percent: '18%'
				},
				{
					x: 'First Round:\nGrand Canyon\nvs. Maryland',
					y: 1455,
					vs: 'Grand Canyon vs. Maryland',
					conference: 'WAC v Big Ten',
					seed: '13 vs. 4',
					team: 'Maryland',
					dow: 'Friday',
					network: 'TBS',
					percent: '57%'
				},
				{
					x: 'Second Round:\nMichigan vs.\nTexas A&M',
					y: 8536,
					vs: 'Michigan vs. Texas A&M',
					conference: 'Big Ten v SEC',
					seed: '5 vs. 4',
					team: 'Michigan',
					dow: 'Saturday',
					network: 'CBS',
					percent: '18%'
				},
				{
					x: 'First Round:\nNorfolk vs.\nFlorida',
					y: 1879,
					vs: 'Norfolk vs. Florida',
					conference: 'MEAC v SEC',
					seed: '16 vs. 1',
					team: 'Florida',
					dow: 'Friday',
					network: 'TNT',
					percent: '49%'
				}
			]
		},
		{
			name: 'Out of Home Live + SD AA (000)',
			data: [
				{
					x: ['Second Round:', 'Drake vs. Texas', 'Tech'],
					y: 1990,
					vs: 'Drake vs. Texas Tech',
					conference: 'Missouri v Big 12',
					seed: '6 vs. 3',
					team: 'Texas Tech',
					dow: 'Saturday',
					network: 'TNT',
					percent: '62%'
				},
				{
					x: ['Second Round:', 'Arkansas vs. ST', 'John\'s'],
					y: 1929,
					vs: 'Arkansas vs. ST John\'s',
					conference: 'SEC v Big East',
					seed: '10 vs. 2',
					team: 'Arkansas',
					dow: 'Saturday',
					network: 'CBS',
					percent: '18%'
				},
				{
					x: ['First Round:', 'Grand Canyon', 'vs. Maryland'],
					y: 1926,
					vs: 'Maryland vs. Grand Canyon',
					vs: 'Grand Canyon vs. Maryland',
					conference: 'WAC v Big Ten',
					seed: '13 vs. 4',
					team: 'Maryland',
					dow: 'Friday',
					network: 'TBS',
					percent: '57%'
				},
				{
					x: ['Second Round:', 'Michigan vs.', 'Texas A&M'],
					y: 1862,
					vs: 'Michigan vs. Texas A&M',
					conference: 'Big Ten v SEC',
					seed: '5 vs. 4',
					team: 'Michigan',
					dow: 'Saturday',
					network: 'CBS',
					percent: '18%'
				},
				{
					x: ['First Round:', 'Norfolk vs.', 'Florida'],
					y: 1780,
					vs: 'Norfolk vs. Florida',
					conference: 'MEAC v SEC',
					seed: '16 vs. 1',
					team: 'Florida',
					dow: 'Friday',
					network: 'TNT',
					percent: '49%'
				}
			]
		}
	];
	
	const series3 = [
		{
			name: 'Live + SD AA (000)',
			data: [
				{
					x: 'First Round:\nLipscomb vs.\nIowa State',
					y: 413,
					vs: 'Lipscomb vs. Iowa State',
					conference: 'ASUN v Big 12',
					seed: '14 vs. 3',
					team: 'Iowa State',
					dow: 'Friday',
					network: 'TNT',
					percent: '78%'
				},
				{
					x: 'First Round:\nSIUE vs.\nHouston',
					y: 394,
					vs: 'SIUE vs. Houston',
					conference: 'SIU Edwardsville v Ohio Valley',
					seed: '16 vs. 1',
					team: 'Houston',
					dow: 'Thursday',
					network: 'TBS',
					percent: '77%'
				},
				{
					x: 'First Round:\nMontana vs.\nWisconsin',
					y: 781,
					vs: 'Montana vs. Wisconsin',
					conference: 'Big Sky v Big Ten',
					seed: '14 vs. 3',
					team: 'Wisconsin',
					dow: 'Thursday',
					network: 'TNT',
					percent: '65%'
				},
				{
					x: 'First Round:\nAkron vs.\nArizona',
					y: 725,
					vs: 'Akron vs. Arizona',
					conference: 'MAC v Big 12',
					seed: '13 vs. 4',
					team: 'Arizona',
					dow: 'Friday',
					network: 'TRUTV',
					percent: '64%'
				},
				{
					x: 'Second Round:\nDrake vs. Texas\nTech',
					y: 1244,
					vs: 'Drake vs. Texas Tech',
					conference: 'Missouri v Big 12',
					seed: '11 vs. 3',
					team: 'Texas Tech',
					dow: 'Saturday',
					network: 'TNT',
					percent: '62%'
				}
			]
		},
		{
			name: 'Out of Home Live + SD AA (000)',
			data: [
				{
					x: ['First Round:', 'Lipscomb vs.', 'Iowa State'],
					y: 1450,
					vs: 'Lipscomb vs. Iowa State',
					conference: 'ASUN v Big 12',
					seed: '14 vs. 3',
					team: 'Iowa State',
					dow: 'Friday',
					network: 'TNT',
					percent: '78%'
				},
				{
					x: ['First Round:', 'SIUE vs.', 'Houston'],
					y: 1349,
					vs: 'SIUE vs. Houston',
					conference: 'SIU Edwardsville v Ohio Valley',
					seed: '16 vs. 1',
					team: 'Houston',
					dow: 'Thursday',
					network: 'TBS',
					percent: '77%'
				},
				{
					x: ['First Round:', 'Montana vs.', 'Wisconsin'],
					y: 1449,
					vs: 'Montana vs. Wisconsin',
					conference: 'Big Sky v Big Ten',
					seed: '14 vs. 3',
					team: 'Wisconsin',
					dow: 'Thursday',
					network: 'TNT',
					percent: '65%'
				},
				{
					x: ['First Round:', 'Akron vs.', 'Arizona'],
					y: 1300,
					vs: 'Akron vs. Arizona',
					conference: 'MAC v Big 12',
					seed: '13 vs. 4',
					team: 'Arizona',
					dow: 'Friday',
					network: 'TRUTV',
					percent: '64%'
				},
				{
					x: ['Second Round:', 'Drake vs. Texas', 'Tech'],
					y: 1990,
					vs: 'Drake vs. Texas Tech',
					conference: 'Missouri v Big 12',
					seed: '11 vs. 3',
					team: 'Texas Tech',
					dow: 'Saturday',
					network: 'TNT',
					percent: '62%'
				}
			]
		}
	];
	
	const xLabels1 = [
		['Championship', 'Telecast: Houston', 'vs. Florida'], 
		['Final Four:', 'Florida vs.', 'Auburn'], 
		['Final Four:', 'Duke vs.', 'Houston'], 
		['Regional Finals:', 'Michigan ST', 'vs. Auburn'], 
		['Second Round:', 'Baylor vs.', 'Duke']
	];
	
	const xLabels2 = [
		['Second Round:', 'Drake vs. Texas', 'Tech'], 
		['Second Round:', 'Arkansas vs. ST', 'John\'s'], 
		['First Round:', 'Grand Canyon', 'vs. Maryland'], 
		['Second Round:', 'Michigan vs.', 'Texas A&M'],
		['First Round:', 'Norfolk vs.', 'Florida']
	];
	
	const xLabels3 = [
		['First Round:', 'Lipscomb vs.', 'Iowa State'], 
		['First Round:', 'SIUE vs.', 'Houston'], 
		['First Round:', 'Montana vs.', 'Wisconsin'], 
		['First Round:', 'Akron vs.', 'Arizona'], 
		['Second Round:', 'Drake vs. Texas', 'Tech']
	];
	
	const dataTicks = [
		{
			total: 20000,
			stepSize: 2000,
		},
		{
			total: 12000,
			stepSize: 2000,
		},
		{
			total: 3500,
			stepSize: 500,
		},
	];
	
	function createGraph(item, series, xLabels, dataTicks) {
		if (!item || !item.isConnected) return null;
		
		try {
			var options = {
				series: series,
				colors: ['#E2185B', '#1E7CAE'],
				fill: {
					opacity: 1,
				},
				chart: {
					type: 'bar',
					stacked: true,
					fontFamily: 'Aeonik',
					width: '100%',
					height: '100%',
					redrawOnParentResize: true,
					toolbar: {
						show: false,
					},
					animations: {
						enabled: true,
						easing: 'easeinout',
						speed: 800,
						animateGradually: {
							enabled: true,
							delay: 150
						},
						dynamicAnimation: {
							enabled: true,
							speed: 350
						}
					}
				},
				grid: {
					borderColor: 'rgba(255, 255, 255, 0.2)',
					padding: {
						top: 0,
						right: 0,
						bottom: 0,
						left: 0
					},
					xaxis: {
						lines: {
							show: false,
						}
					},
				},
				dataLabels: {
					formatter: function (value, { seriesIndex, dataPointIndex, w }) {
						if (
							w.globals.dom.baseEl === $viewershipGraph3 &&
							w.config.series[seriesIndex].name === 'Out of Home Live + SD AA (000)'
						) {
							const totalAtPoint = w.globals.stackedSeriesTotals[dataPointIndex];
							const pct = Math.round((value / totalAtPoint) * 100);
							return [
								value.toLocaleString(),
								`(${pct}%)`
							];
						} else {
							return value.toLocaleString();
						}
					},
				},
				xaxis: {
					type: 'category',
					categories: xLabels,
					axisTicks: {
						show: false,
					},
					labels: {
						rotate: 0,
						maxHeight: undefined,
						offsetY: 0,
						style: {
							fontFamily: 'Aeonik',
							colors: ['rgba(255, 255, 255, 1)', 'rgba(255, 255, 255, 1)', 'rgba(255, 255, 255, 1)', 'rgba(255, 255, 255, 1)', 'rgba(255, 255, 255, 1)'],
						},
					}
				},
				yaxis: {
					max: dataTicks.total,
					stepSize: dataTicks.stepSize,
					labels: {
						style: {
							fontSize: '14px',
							fontFamily: 'Aeonik',
							colors: ['rgba(255, 255, 255, 0.5)'],
						},
						formatter: function(value) {
							return value.toLocaleString() + '\xa0\xa0\xa0\xa0';
						}
					},
				},
				states: {
					hover: {
						filter: {
							type: 'none',
						}
					},
					active: {
						filter: {
							type: 'none',
						}
					}
				},
				responsive: [
					{
						breakpoint: 1300,
						options: {
							xaxis: {
								labels: {
									rotate: -90,
									offsetY: -5,
									style: {
										fontSize: '11px',
										fontFamily: 'Aeonik',
										colors: ['rgba(255, 255, 255, 1)', 'rgba(255, 255, 255, 1)', 'rgba(255, 255, 255, 1)', 'rgba(255, 255, 255, 1)', 'rgba(255, 255, 255, 1)'],
									},
								}
							},
						},
					}
				],
				plotOptions: {
					bar: {
						horizontal: false,
						columnWidth: '90%',
						dataLabels: {
							total: {
								enabled: true,
								style: {
									fontSize: '14px',
									fontWeight: 700,
									color: '#fff'
								},
								offsetY: -10,
								formatter: function(value) {
									return value.toLocaleString();
								}
							}
						}
					},
				},
				legend: {
					position: 'bottom',
					horizontalAlign: 'center',
					offsetX: 40,
					offsetY: 40,
					fontSize: '14px',
					fontFamily: 'Aeonik',
					fontWeight: 700,
					labels: {
						colors: ['#fff', '#fff'],
					},
					markers: {
						size: 6,
						shape: 'circle',
						strokeWidth: 0,
						offsetX: -8,
					},
					itemMargin: {
						horizontal: 12,
						vertical: 0
					},
					onItemClick: {
						toggleDataSeries: false
					}
				},
				tooltip: {
					enabled: true,
					shared: false,
					followCursor: false,
					custom: function({ w, series, seriesIndex, dataPointIndex }) {
						const dataObj = w.config.series[seriesIndex].data[dataPointIndex];
						const yValue = dataObj.y;
						const totalAtPoint = w.globals.stackedSeriesTotals[dataPointIndex];
						const vs  = dataObj.vs;
						const conf  = dataObj.conference;
						const seed  = dataObj.seed;
						const team  = dataObj.team;
						const dow   = dataObj.dow;
						const net   = dataObj.network;
						const pct   = dataObj.percent;
						return `
							<div class="recap-donut-tooltip">
								<div><strong>${vs}</strong></div>
								<div><strong>Conference:</strong> ${conf}</div>
								<div><strong>Seed:</strong>       ${seed}</div>
								<div><strong>Winner:</strong>       ${team}</div>
								<div><strong>Day of Week:</strong> ${dow}</div>
								<div><strong>Network:</strong>    ${net}</div>
								<div><strong>% OOH of Total:</strong>    ${pct}</div>
							</div>
						`;
					}
				},
			};
			
			return new ApexCharts(item, options);
		} catch (error) {
			console.warn('Failed to create viewership graph:', error);
			return null;
		}
	}
	
	function createMobileGraph(item, series, xLabels, dataTicks) {
		if (!item || !item.isConnected) return null;
		
		try {
			var options = {
				series: series,
				colors: ['#E2185B', '#1E7CAE'],
				fill: {
					opacity: 1,
				},
				chart: {
					type: 'bar',
					stacked: true,
					fontFamily: 'Aeonik',
					//width: 'auto',
					height: 453,
					offsetX: -15,
					redrawOnParentResize: false,
					toolbar: {
						show: false,
					},
					animations: {
						enabled: true,
						easing: 'easeinout',
						speed: 800,
						animateGradually: {
							enabled: true,
							delay: 150
						},
						dynamicAnimation: {
							enabled: true,
							speed: 350
						}
					}
				},
				grid: {
					borderColor: 'rgba(255, 255, 255, 0.2)',
					padding: {
						top: 0,
						right: 0,
						bottom: 0,
						left: 0
					},
					xaxis: {
						lines: {
							show: false,
						}
					},
				},
				dataLabels: {
					offsetY: 2,
					style: {
						fontSize: '12px',
						fontFamily: 'Aeonik',
					},
					formatter: function (value, { seriesIndex, dataPointIndex, w }) {
						if (
							w.globals.dom.baseEl === $viewershipMobile3 &&
							w.config.series[seriesIndex].name === 'Out of Home Live + SD AA (000)'
						) {
							const totalAtPoint = w.globals.stackedSeriesTotals[dataPointIndex];
							const pct = Math.round((value / totalAtPoint) * 100);
							return [
								value.toLocaleString(),
								`(${pct}%)`
							];
						} else {
							return value.toLocaleString();
						}
					},
				},
				xaxis: {
					type: 'category',
					categories: xLabels,
					axisTicks: {
						show: false,
					},
					labels: {
						rotate: -90,
						offsetY: -5,
						style: {
							fontSize: '12px',
							fontFamily: 'Aeonik',
							colors: ['rgba(255, 255, 255, 1)', 'rgba(255, 255, 255, 1)', 'rgba(255, 255, 255, 1)', 'rgba(255, 255, 255, 1)', 'rgba(255, 255, 255, 1)'],
						},
					}
				},
				yaxis: {
					max: dataTicks.total,
					stepSize: dataTicks.stepSize,
					labels: {
						style: {
							fontSize: '12px',
							fontFamily: 'Aeonik',
							colors: ['rgba(255, 255, 255, 0.5)'],
						},
						formatter: function(value) {
							return value.toLocaleString() + '\xa0\xa0\xa0\xa0';
						}
					},
				},
				states: {
					hover: {
						filter: {
							type: 'none',
						}
					},
					active: {
						filter: {
							type: 'none',
						}
					}
				},
				plotOptions: {
					bar: {
						horizontal: false,
						columnWidth: '90%',
						dataLabels: {
							total: {
								enabled: true,
								style: {
									fontSize: '12px',
									fontWeight: 700,
									color: '#fff'
								},
								offsetY: -10,
								formatter: function(value) {
									return value.toLocaleString();
								}
							}
						}
					},
				},
				legend: {
					position: 'bottom',
					horizontalAlign: 'left',
					offsetY: 40,
					offsetX: -15,
					itemMargin: {
						horizontal: 0,
						vertical: 5
					},
					fontSize: '12px',
					fontFamily: 'Aeonik',
					fontWeight: 700,
					labels: {
						colors: ['#fff', '#fff'],
					},
					markers: {
						size: 6,
						shape: 'circle',
						strokeWidth: 0,
						offsetX: -8,
					},
					onItemClick: {
						toggleDataSeries: false
					}
				},
				tooltip: {
					enabled: true,
					shared: false,
					followCursor: false,
					custom: function({ w, series, seriesIndex, dataPointIndex }) {
						const dataObj = w.config.series[seriesIndex].data[dataPointIndex];
						const yValue = dataObj.y;
						const totalAtPoint = w.globals.stackedSeriesTotals[dataPointIndex];
						const vs  = dataObj.vs;
						const conf  = dataObj.conference;
						const seed  = dataObj.seed;
						const team  = dataObj.team;
						const dow   = dataObj.dow;
						const net   = dataObj.network;
						const pct   = dataObj.percent;
						return `
							<div class="recap-donut-tooltip">
								<div><strong>${vs}</strong></div>
								<div><strong>Conference:</strong> ${conf}</div>
								<div><strong>Seed:</strong>       ${seed}</div>
								<div><strong>Winner:</strong>       ${team}</div>
								<div><strong>Day of Week:</strong> ${dow}</div>
								<div><strong>Network:</strong>    ${net}</div>
								<div><strong>% OOH of Total:</strong>    ${pct}</div>
							</div>
						`;
					}
				},
			};
			
			return new ApexCharts(item, options);
		} catch (error) {
			console.warn('Failed to create mobile viewership graph:', error);
			return null;
		}
	}
	
	function createIntersectionObserver(element, series, xLabels, dataTicks) {
		if (!element || !element.isConnected) return null;
		
		// Create the chart immediately but don't render it yet
		const chart = createGraph(element, series, xLabels, dataTicks);
		if (!chart) return;
		
		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					// Only render the chart when it comes into view
					chart.render();
					observer.disconnect();
				}
			});
		}, {
			threshold: 1.0
		});
		
		observer.observe(element);
	}
	
	// Create Intersection Observer for each chart
	if ($viewershipGraph.length) {
		createIntersectionObserver($viewershipGraph[0], series1, xLabels1, dataTicks[0]);
	}
	
	if ($viewershipGraph2.length) {
		createIntersectionObserver($viewershipGraph2[0], series2, xLabels2, dataTicks[1]);
	}

	if ($viewershipGraph3.length) {
		createIntersectionObserver($viewershipGraph3[0], series3, xLabels3, dataTicks[2]);
	}
	
	if ($viewershipMobile1.length) {
		const mobileChart1 = createMobileGraph($viewershipMobile1[0], series1, xLabels1, dataTicks[0]);
		mobileChart1.render();
	}
	
	if ($viewershipMobile2.length) {
		const mobileChart2 = createMobileGraph($viewershipMobile2[0], series2, xLabels2, dataTicks[1]);
		mobileChart2.render();
	}
	
	if ($viewershipMobile3.length) {
		const mobileChart3 = createMobileGraph($viewershipMobile3[0], series3, xLabels3, dataTicks[2]);
		mobileChart3.render();
	}
	
}

export { viewershipGraphs };